import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=2e731b32&scoped=true&"
import script from "./Radio.vue?vue&type=script&lang=js&"
export * from "./Radio.vue?vue&type=script&lang=js&"
import style0 from "./Radio.vue?vue&type=style&index=0&id=2e731b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e731b32",
  null
  
)

export default component.exports